// NOTE: Dependencies: jQuery, Defiant

(function ($) {
	$.fn.lmProductItem = function(options) {

		const $context = $(this);

		// check is dom element is defined 
		if (!this.length) {
			return false;
		}

		// Default settings are set here.
		var settings = $.extend({
			$body: $('body'),
			productItem: '.product-item',
			productCheckBox: '.product-item__checkbox',
			productCheckBoxChecked: '.product-item__checkbox:checked',
			productCompareBar: '.product-item__compare-bar',
			productLabel: '.product-item__compare-label',
			productCompareActive: 'product-item__compare--active',
			productCompareDisabled: 'product-item__compare-bar--disabled',
			productColActive: 'grid__col--border-active',
			productSliderActive: 'slider__slide--active',
			gridCol: '.grid__col',
			$compareBtn: $('.compare-bar__btn'),
			$compareCount: $('.compare-bar__count'),
			$compareLabel: $('.compare-bar__product-label'),
			compareBtnDisabledClass: 'compare-bar__btn--disabled',
			compareCountActiveClass: 'compare-bar__count--active',
			compareLabelActiveClass: 'compare-bar__product-label--active',
			$clearAllBtn: $('.compare-bar__clear-all-btn'),
			clearAllDisabledClass: 'compare-bar__clear-all-btn--disabled',
			comparisonData: [],
			$productsHidden: $('#productsHidden'),
			$compareForm: $('#formCompare')
		}, options);

		// These are all the methods available for the plugin.
		var	methods = {};

		methods.setCurrentSettings = function() {
			var currentSettings = $context.data();

			if (!$.isEmptyObject(currentSettings)) {	
				$context.data($.extend({}, settings, currentSettings));
			} else {
				$context.data(settings);
			}

			// Initialize item.
			$context.data('initialized', true);

			settings.$grid = $context.closest('.grid');
			settings.$productCompareBar = $context.find(settings.productCompareBar);
			settings.$productCheckBox = $context.find(settings.productCheckBox);
		};

		// Toggle Active Classes
		methods.toggle = function () {
			$context.toggleClass(settings.activeClass);
		};

		// Bind events
		methods.events = function() {

			settings.$compareBtn.on('click.lmProductItem', function(event) {
				event.preventDefault();

				if (!$(this).hasClass(settings.compareBtnDisabledClass)) {
					settings.$compareForm.submit();
				}
			});

			$context.find('.product-item__key-info').on( 'mouseenter', function() {
				var $this = $(this),
					$productItemParent = $this.parent().parent().parent();

				// Global function made
				methods.productAdd($this, $productItemParent);

			}).on( 'mouseleave', function() {
				var $this = $(this),
					$productItemParent = $this.parent().parent().parent();

				// Global function made
				methods.productRemove($this, $productItemParent);	

			});

			// Clear button
			settings.$clearAllBtn.on('click.lmProductItem', function(event) {
				event.preventDefault();

				if (!$(this).hasClass(settings.clearAllDisabledClass)) {

					// Remove links in items
					$(settings.productCheckBoxChecked).closest(settings.productCompareBar).removeClass(settings.productCompareActive).find(settings.productLabel + ' button').contents().unwrap();

					// Set checkbox to unchecked
					$(settings.productCheckBox).prop('checked', false);

					// Removing disabled classes
					$(settings.productCheckBox + ':disabled').attr('disabled', false).closest(settings.productCompareBar).removeClass(settings.productCompareDisabled);

					// Disable compare button
					methods.disableCompareBtn(0);

					// Disable clear button
					settings.$clearAllBtn.addClass(settings.clearAllDisabledClass);

					// Emptying hidden inputs
					settings.$productsHidden.val('');
				}
			});

			// Unbinding document important to avoid multiple calls
			// On change of select checkbox
			$(document).unbind().on( 'change.lmProductItem', '.product-item ' + settings.productCheckBox, function(event) {
				event.preventDefault();

				// Setting variables
				var $this = $(this),
					$currentGrid = $this.closest('.grid'),
					// Leaving commented so can keep track of commented code below and also fix ESlint issues.
					// $productItem = $this.closest(settings.productItem),
					// $productItemParent = $productItem.parent().parent(),
					// activeCount = $currentGrid.find('.' + settings.productCompareActive).length,
					// $productCompareBar = $(this).closest(settings.productCompareBar),
					// id = $(this).attr('id'),
					checkedCount = $currentGrid.find(settings.productCheckBoxChecked).length;

				// Have to clear and populate array every time because of dynamic content brough in from ajax calls
				settings.comparisonData = [];

				$(document).find('.product-item ' + settings.productCheckBox).each(function() {
					var $this = $(this);

					if ($this.is(':checked')) {
						settings.comparisonData.push($this.attr('id'));
					}
				});

				// Copying comparison data object to var
				var comparisonData = settings.comparisonData;
				
				// Convert to string
				comparisonData = comparisonData.toString();

				// Setting hidden inputs to string
				settings.$productsHidden.val(comparisonData);

				// If checked count is greater than one or less than 6
				if (checkedCount > 1 && checkedCount < 5) {
					$currentGrid.find(settings.productCheckBox).attr('disabled', false).closest(settings.productCompareBar).removeClass(settings.productCompareDisabled);

					// If checked
					if ($this.is(':checked') == true) {

						// Global function made
						// Leaving commented out until Miguel confirms functionality
						//methods.productAdd($this, $productItemParent);

						var productBar = $currentGrid.find(settings.productCheckBoxChecked).closest(settings.productCompareBar);

						productBar.addClass(settings.productCompareActive);
						productBar.removeClass(settings.productCompareDisabled).find(settings.productLabel).contents().filter(function(){
							return this.nodeType !== 1;
						}).wrap('<button />');

						methods.updateCompareBtn(checkedCount);

						productBar.find('button').on('click', function(event) {
							event.preventDefault();

							// Submit form
							settings.$compareForm.submit();

						});

					} else {

						methods.updateCompareBtn(checkedCount);

						// Global function made
						// Leaving commented out until Miguel confirms functionality
						//methods.productRemove($this, $productItemParent);

						// Unwrap link
						$this.closest(settings.productCompareBar).removeClass(settings.productCompareActive).find(settings.productLabel + ' button').contents().unwrap();
					}

					// Disabling checkboxes if equal to 5
					if (checkedCount == 4) {
						$currentGrid.find('input:checkbox:not(:checked)').attr('disabled', true).closest(settings.productCompareBar).addClass(settings.productCompareDisabled);
					}

					// Activate clear button
					settings.$clearAllBtn.removeClass(settings.clearAllDisabledClass);

				} else {

					// Activate/deactivate clear button
					if (checkedCount == 1) {
						settings.$clearAllBtn.removeClass(settings.clearAllDisabledClass);
					} else {
						settings.$clearAllBtn.addClass(settings.clearAllDisabledClass);
					}

					methods.disableCompareBtn(checkedCount);

					// Removing restting all classes
					$this.closest(settings.productCompareBar).removeClass(settings.productCompareActive).find(settings.productLabel + ' button').contents().unwrap();
					$currentGrid.find(settings.productCheckBoxChecked).closest(settings.productCompareBar).removeClass(settings.productCompareActive).find(settings.productLabel + ' button').contents().unwrap();

					// Adding grid borders
					if ($this.is(':checked') == true) {
						
						// Global function made
						// Leaving commented out until Miguel confirms functionality
						//methods.productAdd($this, $productItemParent);
						
					} else {

						// Global function made
						// Leaving commented out until Miguel confirms functionality
						//methods.productRemove($this, $productItemParent);					
					}
				}

			});			
		};

		methods.updateCompareBtn = function(checkedCount) {
			settings.$compareCount.text(checkedCount).addClass(settings.compareCountActiveClass);
			settings.$compareLabel.addClass(settings.compareLabelActiveClass);
			settings.$compareBtn.removeClass(settings.compareBtnDisabledClass);
		};

		methods.disableCompareBtn = function() {
			settings.$compareCount.text('').removeClass(settings.compareCountActiveClass);
			settings.$compareLabel.removeClass(settings.compareLabelActiveClass);
			settings.$compareBtn.addClass(settings.compareBtnDisabledClass);
		};

		// Global function to add/remove classes
		methods.productAdd = function($item, $itemParent) {
			if ($itemParent.hasClass('slider__slide')) {
				$itemParent.addClass(settings.productSliderActive);
			} else {
				$item.closest(settings.gridCol).addClass(settings.productColActive);
			}
		};

		methods.productRemove = function($item, $itemParent) {
			if ($itemParent.hasClass('slider__slide')) {
				$itemParent.removeClass(settings.productSliderActive);
			} else {
				$item.closest(settings.gridCol).removeClass(settings.productColActive);
			}
		};

		// On load function.
		methods.initContext = function () {
			methods.setCurrentSettings();
		};

		// Filter each function.
		methods.filterEach = function() {
			return !$(this).data('initialized');
		};

		// Methods to run inside loop.
		return this.filter(methods.filterEach).each(function() {
			// NOTE: Method you'd like initialized on a per context basis.
			methods.initContext($(this));

			// Run once methods when jquery plugin is called.
			methods.events(this);
		});
		
	};

	if($('.product-item').length) {
		$('.product-item').lmProductItem();
	}

}(jQuery));